import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    /* CSSTransition start*/
    .fade-enter {
        opacity: 0;
    }

    .fade-exit {
      opacity: 1;
      position: absolute;
      top: 0px;
      left: 0;
      width: 100%;
    }

    .fade-enter-active {
        opacity: 1;
    }

    .fade-exit-active {
        opacity: 0;
    }

    .fade-enter-active,
    .fade-exit-active {
        transition: opacity 200ms;
    }
    /* CSSTransition end */
`;

export default GlobalStyle;
